import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PASSWORD_HINT =
  'Almeno 5 caratteri, con una maiuscola, una minuscola, un numero e un simbolo.';

/** Stesse regole del backend (IsStrongPassword). */
export function strongPassword(control: AbstractControl): ValidationErrors | null {
  const value = (control.value ?? '') as string;
  if (!value) return null;
  const ok =
    value.length >= 5 &&
    /[a-z]/.test(value) &&
    /[A-Z]/.test(value) &&
    /\d/.test(value) &&
    /[^A-Za-z0-9]/.test(value);
  return ok ? null : { strongPassword: true };
}
